import { useMemo } from 'react'
import useCartState from './useCartState'
import { useOrderState } from './useOrderState'
import useSession, { resolveDealsContext } from 'hooks/useSession'

export const useSavedOrderState = (savedOrderId?: string) => {
  const currentState = useOrderState()
  const savedOrders = useCartState((s) => s.orders)
  const deals = useSession((s) => s.deals)

  const saved = useMemo(() => {
    if (!savedOrderId) return undefined
    const savedOrder = savedOrders.find((o) => o.id === savedOrderId)
    if (!savedOrder) return undefined
    return savedOrder
  }, [savedOrderId, savedOrders])

  if (saved) {
    return {
      order: saved.order,
      result: saved.result,
      discounts: saved.discounts,
      deals: saved.deals,
    }
  }

  return {
    order: currentState.order,
    result: currentState.result,
    discounts: currentState.discounts,
    deals: resolveDealsContext(deals),
  }
}

export default useSavedOrderState
